import Http from '../../../../http';
import {
  FETCH_PO_VENDORS,
  FETCH_PO_VENDORS_ERROR,
  FETCH_PO_VENDORS_SUCCESS,
  FETCH_PO_VENDOR,
  FETCH_PO_VENDOR_ERROR,
  FETCH_PO_VENDOR_SUCCESS,
  PO_VENDOR_CREATED,
  PO_VENDOR_UPDATED,
} from './constants';


export const fetchVendorsStart = () => ({
  type: FETCH_PO_VENDORS,
});

export const fetchVendorsSuccess = data => ({
  type: FETCH_PO_VENDORS_SUCCESS,
  payload: data,
});

export const fetchVendorsError = error => ({
  type: FETCH_PO_VENDORS_ERROR,
  payload: error,
});

export const fetchVendors = brandId => (dispatch) => {
  dispatch(fetchVendorsStart());
  return Http.get(`/brand/${brandId}/vendor`)
    .then((data) => {
      dispatch(fetchVendorsSuccess(data.rows));
      return data;
    })
    .catch((error) => {
      dispatch(fetchVendorsError(error));
      throw error;
    });
};

export const fetchVendorStart = () => ({
  type: FETCH_PO_VENDOR,
});

export const fetchVendorSuccess = data => ({
  type: FETCH_PO_VENDOR_SUCCESS,
  payload: data,
});

export const fetchVendorError = error => ({
  type: FETCH_PO_VENDOR_ERROR,
  payload: error,
});

export const fetchPoVendor = (brandId, vendorId) => (dispatch) => {
  dispatch(fetchVendorStart());
  return Http.get(`/brand/${brandId}/vendor/${vendorId}`)
    .then((data) => {
      dispatch(fetchVendorSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(fetchVendorError(error));
      throw error;
    });
};

export const poVendorCreated = vendor => ({
  type: PO_VENDOR_CREATED,
  payload: vendor,
});

export const poVendorUpdated = vendor => ({
  type: PO_VENDOR_UPDATED,
  payload: vendor,
});

export const createPoVendor = (brandId, newVendor) => dispatch => (
  Http.post(`/brand/${brandId}/vendor`, newVendor)
    .then((data) => {
      dispatch(poVendorCreated(data));
      return data;
    })
);

export const updatePoVendor = (brandId, update) => dispatch => (
  Http.put(`/brand/${brandId}/vendor/${update.id}`, update)
    .then((data) => {
      dispatch(poVendorUpdated(data));
      return data;
    })
);
